import {initFlowbite} from 'flowbite';
import {init as initUserCharts} from "../features/user-charts.js";
import {init as initTooltip} from "../widgets/tooltip.js";
import {init as initToastUI} from "../widgets/toastui.js";
import {init as initCalendar} from "../widgets/calendar.js";
import {init as initUppy} from "../forms/challenge-sources-upload.js";
import {init as initSwal} from "../features/swal.js";
import {init as initMaps} from "../integrations/maps/index.js";
import {init as initModal} from "../widgets/modal.js";
import {init as initCountDown} from "../widgets/countdown.js";
import {init as initChallengeForm} from "../forms/challenge-form.js";
import {init as initForm} from "../forms/form.js";
import {init as initAvatarUpload} from "../forms/avatar-upload.js";

/**
 * Initializes all UI components for a given parent element
 * @param {HTMLElement} parent - Parent element to initialize components within
 */
export function initUI(parent = document) {
    const initializers = [
        initUppy,
        initChallengeForm,
        initCountDown,
        initForm,
        initAvatarUpload,
        initCalendar,
        initUserCharts,
        initTooltip,
        initToastUI,
        initModal,
        initSwal,
        initMaps
    ];

    initializers.forEach(initializer => initializer(parent));
}

/**
 * Initializes the application on HTMX load
 */
export function setupHTMXLoadHandler(processTeleportedTemplates) {
    htmx.onLoad((content) => {
        initFlowbite();
        initUI(content);
        processTeleportedTemplates();
    });
}
